import { Button, Col, Form, Row, Space, Typography } from 'antd';
import React, { ReactElement, useState, useRef } from 'react';
import { FormOTPInput } from '../crmFormElement/FormInput';
import { GUTTOR_SPACE } from '../../constants/commonConstants';
import { ReactComponent as RoundTickIcon } from '../../../assets/images/svg/i_round_tick.svg';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import './EmailVerificationChildComponents.less';
import { correctEmail, emailVerificationVerifyOtp, incorrectEmail, setEncryptedToken, skippedEmailVerification } from '../../../store/actions/authAction';
import { centeredNotification } from '../../../utils/utility';
import { setEmailVerifyModalShow } from '../../../store/actions/mailBoxAction';
import { setIsUserEmailVerified } from '../../../store/actions/hospitalAction';

export const AlertEmailVerificationModal = (props: any): ReactElement => {
  const [disableConfirmButton, setDisableConfirmButton] = useState(false);
  const dispatch = useDispatch();
  const { goNext, userEmail, userName, providerId } = props;
  const onIncorrect = (): void => {
    const payload = {
      IsMarkedIncorrect: true,
      providerId,
      userName,
    };
    dispatch(incorrectEmail(payload, onInCorrectEmailSuccess));
  };
  const onCorrect = (): void => {
    const payload = {
      emailId: userEmail,
      providerId,
      userName,
    };
    setDisableConfirmButton(true);
    dispatch(correctEmail(payload, onOTPSentSuccess));
  };
  const onOTPSentSuccess = (token: string): void => {
    setDisableConfirmButton(false);
    goNext(1);
    dispatch(setEncryptedToken(token));
  };
  const onInCorrectEmailSuccess = (): void => {
    goNext(-1);
    localStorage.setItem('isEmailVerificationRequired', 'false');
  };
  const onSkipSuccess = (): void => {
    localStorage.setItem('isEmailVerificationRequired', 'false');

    dispatch(setEmailVerifyModalShow(false));
  };
  const onSkip = (): void => {
    const payload = {
      IsSkip: true,
      providerId,
      userName,
    };
    dispatch(skippedEmailVerification(payload, onSkipSuccess));
  };
  return (
    <div>
      <Row gutter={GUTTOR_SPACE} justify="center" className="mb-sm">
      <Col>
          <h2>Verification</h2>
        </Col>
        <Col>
          <p className="text-align-center">As per our records the email ID associated with this account is
            <b> {userEmail}</b>. If it is correct, please confirm.</p>
        </Col>
        <Col >
          <Space>
            <Button onClick={onIncorrect}> Incorrect </Button>
            <Button type={'primary'} onClick={onCorrect} disabled={disableConfirmButton}>
              Confirm
            </Button>
          </Space>
        </Col>
      </Row>
      <Col className={'text-right'}>
        <p onClick={onSkip} className={'skip-verification'}>Skip</p>
      </Col>
    </div>
  );
};

export const EmailIncorrectModal = (props: any): ReactElement => {
  const dispatch = useDispatch();
  const {goNext} = props;
  const onClose = (): void => {
    dispatch(setEmailVerifyModalShow(false));
    goNext(1);
  };

  return (
    <div>
      <Row gutter={GUTTOR_SPACE} justify="center" className="mb-sm">
        <strong className="text-align-center">
          Your response has been recorded, IHX representative will reach out for email ID updation.</strong>
      </Row>
      <Row gutter={GUTTOR_SPACE} justify="center">
        <Col md={4}>
          <Button type="primary" onClick={onClose}>Close</Button>
        </Col>
      </Row>
    </div>
  );
};

export const EnterOTPModal = (props: any): ReactElement => {
  const { Text } = Typography;
  const dispatch = useDispatch();
  const { encryptedTokenAuth } = useSelector((state: RootState): any => state.auth);
  const { goNext, userEmail, userName, providerId } = props;
  const otpInputRef = useRef<{ resetOTP: () => void }>(null);
  const [form] = Form.useForm();
  const [counter, setCounter] = useState(0);
  const [inValidOtp, setInValidOtp] = useState(false);
  const [resendClicked, setIsResendClicked] = useState(false);
  const onBack = (): void => {
    goNext(-1);
  };

  const onOTPSentSuccess = (token: string): void => {
    dispatch(setEncryptedToken(token));
  };

  const onSuccess = (): any => {
    localStorage.setItem('isEmailVerificationRequired', 'false');
      goNext(1);
    dispatch(setIsUserEmailVerified(true));
  };
  const onError = (errorMessage: string): void => {
    if (errorMessage === 'OTP Verification Limit Crossed') {
      centeredNotification(errorMessage + ' Please click on resend button for verification of OTP');
    } else {
      setInValidOtp(true);
      setIsResendClicked(false);
    }
  };

  const verifyOtp = (): void => {
    const payload = {
      encryptedToken: encryptedTokenAuth,
      otp: (form.getFieldsValue()).otp,
      emailId: userEmail,
      userName,
      providerId,
    };
    dispatch(emailVerificationVerifyOtp(payload, onSuccess, onError));
  };

  const resendOtp = (): void => {
    setCounter(counter + 1);
    setInValidOtp(false);
    if (counter < 5) {
      if (otpInputRef?.current) {
        otpInputRef?.current?.resetOTP();  // add null-check
      }
    const payload = {
      emailId: userEmail,
      providerId,
      userName,
    };
    setIsResendClicked(true);
    dispatch(correctEmail(payload, onOTPSentSuccess));
  } else {
    const payload = {
      IsMarkedIncorrect: true,
      providerId,
      userName,
    };
    dispatch(incorrectEmail(payload, onMultipleResend));
  }
  };
  const onMultipleResend = (): void => {
    localStorage.setItem('isEmailVerificationRequired', 'false');
    goNext(2);

  };
  return (
    <div>
      <Row gutter={GUTTOR_SPACE} justify="center" className="mb-sm">
        <strong className="text-default">An OTP has been sent to your email {userEmail}</strong>
      </Row>
      <Row gutter={GUTTOR_SPACE} justify="center">
        <p>Please enter the OTP below and Submit</p>
      </Row>
      <Row gutter={GUTTOR_SPACE} justify="center">
        {resendClicked && <p className="successful-text">OTP Resent Successfully!</p>}
      </Row>
      <Row gutter={GUTTOR_SPACE} justify="center">
        <Form
          form={form}
          onFinish={verifyOtp}>
          <Col>
            <FormOTPInput
              form={form}
              autoFocus={true}
              length={5}
              className="otpContainer"
              inputClassName={inValidOtp ? 'wrongOtpInput' : 'otpInput'}
              ref={otpInputRef}
            />
          </Col>
          {inValidOtp && <Row justify="center">
            <Col md={9}>
              <div>
                <span><Text type="danger">Invalid OTP?</Text></span>
              </div>
            </Col>
            <Col md={7}>
              <div
                className="resend-otp-container">
                <strong><p className="mouse-pointer" onClick={resendOtp} >Resend</p></strong>
              </div>
            </Col>
          </Row>}
          <Row justify="center">
            <Col md={7}>
              <Button type="default" htmlType="submit" onClick={onBack}>
                Back
              </Button>
            </Col>
            <Col md={7}>
              <Button
                type="primary"
                htmlType="submit"
              >
                Submit
              </Button>
            </Col>
          </Row>
        </Form>
      </Row>
    </div>
  );
};

export const SuccessModal = (props: any): ReactElement => {

  return (
    <>
      <Row gutter={GUTTOR_SPACE} justify="center" className="mb-sm">
        <strong><RoundTickIcon className="fill-success" /></strong>
      </Row>
      <Row gutter={GUTTOR_SPACE} justify="center" className="mb-sm">
        <strong className="text-success">You have successfully verified your Email</strong>
      </Row>
    </>
  );
};

export const MultipleIncorrectInputModal = (props: any): ReactElement => {
  const dispatch = useDispatch();
  const onClose = (): void => {
    dispatch(setEmailVerifyModalShow(false));
  };

  return (
    <div>
      <Row gutter={GUTTOR_SPACE} justify="center" className="mb-sm">
        <strong className="text-align-center">
          Your response has been recorded as an incorrect Email due to multiple wrong OTP input
           IHX representative will reach out for email ID updation.</strong>
      </Row>
      <Row gutter={GUTTOR_SPACE} justify="center">
        <Col md={4}>
          <Button type="primary" onClick={onClose}>Close</Button>
        </Col>
      </Row>
    </div>
  );
};
